export default "__VITE_ASSET__db315016__"